export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manas.4665d47b.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};